import * as React from 'react';

import type { WorkOrderEmployeeVM } from 'ab-viewModels/workOrder/workOrderFieldReportCard.viewModel';

import Checkbox from 'af-components/Controls/Checkbox';

interface OwnProps {
	assignedToIds: number[];
	change: (key: string, value: Nullable<number[]>) => void;
	employee: WorkOrderEmployeeVM;
	index: number;
	name: string;
}

type Props = OwnProps;

const WorkOrderEmployeeCheckbox: React.FC<Props> = (props: Props) => {
	const { employee, assignedToIds, name, change } = props;

	const renderLabel = () => {
		return (
			<span>
				{employee.fullName}
				{employee.isLastSignee &&
					<span className="work-order-report-reject-modal__signee">Report Signee</span>
				}
			</span>
		);
	};

	const getFieldIndex = React.useCallback(() => {
		return assignedToIds?.findIndex((_field) => _field === employee.id) ?? -1;
	}, [assignedToIds, employee]);

	const onCheck = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const isChecked = e.target.checked;

		const newIds = [...assignedToIds];
		if (isChecked) {
			newIds.push(employee.id);
		} else {
			const employeeIndex = getFieldIndex();
			if (employeeIndex >= 0) {
				newIds.splice(employeeIndex, 1);
			}
		}
		change(name, newIds.length ? newIds : null);
	}, [name, assignedToIds, change, getFieldIndex, employee]);

	const isChecked = getFieldIndex() >= 0;

	return (
		<Checkbox
			handleChange={onCheck}
			id={employee.id.toString()}
			isChecked={isChecked}
			isStandalone={true}
			label={renderLabel()}
		/>
	);
};

export default React.memo(WorkOrderEmployeeCheckbox);
